import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Course } from 'models/course';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { RestApiService } from '../rest-api/rest-api.service';
import { AutoCompleteListItemInterface } from './interfaces/auto-complete.interfaces';

@Injectable()
export class AscService {
    constructor(private _restApiService: RestApiService) {}

    private _$resultList: BehaviorSubject<Course[]> = new BehaviorSubject([]);

    public get resultList$(): Observable<Course[]> {
        return this._$resultList.asObservable();
    }

    public setResultList(list: Course[]) {
        this._$resultList.next(list);
    }

    public getHighlightedString(result: AutoCompleteListItemInterface, searchTerm: string): string {
        if (!searchTerm) {
            return result.label;
        }
        const currentSearchTerms = searchTerm
            .trim()
            .replace(/ +/g, ' ')
            .replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
            .split(' ')
            .join('|');
        const searchRegExp = new RegExp(`(^(${currentSearchTerms})|\\W(${currentSearchTerms}))`, 'gi');
        return result.label.replace(searchRegExp, (matched) => {
            return matched.charAt(0) === ' ' ? ` <strong>${matched.slice(1)}</strong>` : `<strong>${matched}</strong>`;
        });
    }

    public getSuggestions(
        requestUrl: string,
        searchString: string,
        returnReversed: boolean = false
    ): Promise<Array<AutoCompleteListItemInterface>> {
        const _options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            }),
            responseType: 'json'
        };
        return this._restApiService
            .requestGET<Array<AutoCompleteListItemInterface>>(`${requestUrl}/${searchString}`, _options)
            .then((data: Array<AutoCompleteListItemInterface>) => {
                if (returnReversed) {
                    data.reverse();
                }
                return data.map((entry) => (typeof entry !== 'string' ? entry : { label: entry }));
            });
    }
}
